// Download helpers for Skill Gap Assessment results

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import type { SubmitResponse } from "./types";

export function downloadJson(
  submitResponse: SubmitResponse,
  workflowId: string
): void {
  const blob = new Blob([JSON.stringify(submitResponse, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `skill-gap-${workflowId}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadPdf(
  resultsEl: HTMLElement,
  workflowId: string
): Promise<void> {
  const canvas = await html2canvas(resultsEl, { scale: 2 });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const imgHeight = (canvas.height * pageWidth) / canvas.width;
  pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
  pdf.save(`skill-gap-${workflowId}.pdf`);
}
